/*
 * EditPassword Messages
 *
 * This contains all the text for the EditPassword scene.
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.scenes.EditPassword";

export default defineMessages(scope, {
  header: "This is the EditPassword scene!",
  securitySettings: "SECURITY SETTINGS",
  updatePassword: "UPDATE PASSWORD",
  passwordRequirements: "Password Requirements:", // NOSONAR
  currentPassword: "Current Password",
  newPassword: "New Password",
  confirmNewPassword: "Confirm New Password",
  cancel: "Cancel",
  save: "Save",
  mfaSettings: "MFA Settings",
  password: "Password", // NOSONAR
  edit: "Edit",
  phone: "Phone Authentication",
  okta: "Okta Verify",
  app: "Authenticator App",
  email: "Email Authentication",
  done: "Done",
  success: "Success",
  passwordUpdated: "Password Updated.", // NOSONAR
  errMsgRequiredField: "This field is required!",
  errMsgMaxLength: "Must be at least {changedValue} characters",
  errMsgUserName: "Must not contain your username",
  errMsgLastName: "Must not contain your last name",
  errMsgFirstName: "Must not contain your first name",
  errMsgLowerCase: "Must contain a lowercase letter",
  errMsgUpperCase: "Must contain an uppercase letter",
  errMsgSpecialChar: "Must contain a special character",
  errMsgNumber: "Must contain a number",
  errMsgUnconfirmedPassword: `Passwords do not match`,
  errMsgUnchangedUsername: `Your new username cannot be the same as your old username.`,
  genericErrorHeader: `Error`,
  genericErrorMessage: `Unable to update. Please try again later.`,
  tryAgainErrorMessage: "Please try again",
});
